import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2469efa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "src-config-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "src-alert-banner" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "64 64 896 896",
    width: "16",
    height: "16",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "温馨提示："),
    /*#__PURE__*/_createTextVNode("当不同维度的政策发生重叠时，系统将严格按照 "),
    /*#__PURE__*/_createElementVNode("strong", null, "客户 > 省区 > 渠道"),
    /*#__PURE__*/_createTextVNode(" 的优先级生效，请注意检查包含关系。")
  ])
], -1))
const _hoisted_3 = { class: "src-form-section" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "src-section-title" }, "第一步：选择管控维度范围", -1))
const _hoisted_5 = { class: "src-filters" }
const _hoisted_6 = { class: "src-filter-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "src-filter-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "src-req" }, "*"),
  /*#__PURE__*/_createTextVNode("管控维度")
], -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "请选择管控维度", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "channel" }, "渠道", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "shop" }, "省区", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "customer" }, "客户", -1))
const _hoisted_13 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "src-form-section"
}
const _hoisted_15 = { class: "src-section-title" }
const _hoisted_16 = { class: "src-table-card" }
const _hoisted_17 = {
  key: 0,
  class: "src-filters src-sub-search"
}
const _hoisted_18 = { class: "src-filter-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "src-filter-label",
  style: {"width":"80px","text-align":"right"}
}, "客户erp编码", -1))
const _hoisted_20 = { class: "src-filter-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "src-filter-label",
  style: {"width":"80px","text-align":"right"}
}, "经销商名称", -1))
const _hoisted_22 = {
  key: 1,
  class: "src-action-bar"
}
const _hoisted_23 = { class: "src-table-wrapper" }
const _hoisted_24 = { class: "src-data-table" }
const _hoisted_25 = {
  key: 0,
  style: {"width":"40px","text-align":"center"}
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "省区", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "渠道类型", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "销售办公室", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "客户erp编码", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "客户名称", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "销售办公室", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "省区", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "渠道类型", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "src-num-th" }, "促销销售占比(%)", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "src-num-th" }, "让利占比-客户(%)", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "src-num-th" }, "让利占比-省区(%)", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "src-num-th" }, "老品让利幅度(%)", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "src-num-th" }, "新品让利幅度(%)", -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = ["colspan"]
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<div class=\"src-empty-state\" data-v-2469efa4><svg viewBox=\"0 0 64 64\" width=\"64\" height=\"64\" fill=\"#e8e8e8\" data-v-2469efa4><path d=\"M52 20h-8v-4c0-4.4-3.6-8-8-8h-8c-4.4 0-8 3.6-8 8v4h-8c-2.2 0-4 1.8-4 4v28c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V24c0-2.2-1.8-4-4-4zM24 16c0-2.2 1.8-4 4-4h8c2.2 0 4 1.8 4 4v4H24v-4zm28 36H12V24h8v4h24v-4h8v28z\" data-v-2469efa4></path><path fill=\"#d9d9d9\" d=\"M26 32h12v4H26zM26 40h12v4H26z\" data-v-2469efa4></path></svg><div class=\"src-empty-text\" data-v-2469efa4>暂无数据</div></div>", 1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 1,
  class: "src-cell-top"
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "src-select-box" }
const _hoisted_49 = {
  key: 0,
  class: "src-placeholder"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "src-arrow" }, null, -1))
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "src-province-name" }
const _hoisted_54 = { class: "src-cell-top" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "src-select-box" }
const _hoisted_57 = {
  key: 0,
  class: "src-placeholder"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "src-arrow" }, null, -1))
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "src-cell-top" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "src-select-box" }
const _hoisted_64 = {
  key: 0,
  class: "src-placeholder"
}
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "src-arrow" }, null, -1))
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "src-province-name" }
const _hoisted_70 = ["onUpdate:modelValue", "readonly"]
const _hoisted_71 = ["onUpdate:modelValue", "readonly"]
const _hoisted_72 = ["onUpdate:modelValue", "readonly"]
const _hoisted_73 = ["onUpdate:modelValue", "readonly"]
const _hoisted_74 = ["onUpdate:modelValue", "readonly"]
const _hoisted_75 = { class: "src-total" }
const _hoisted_76 = {
  key: 1,
  class: "src-page-actions"
}
const _hoisted_77 = ["disabled"]
const _hoisted_78 = {
  class: "src-modal",
  style: {"width":"520px"}
}
const _hoisted_79 = { class: "src-modal-header" }
const _hoisted_80 = { class: "src-modal-body" }
const _hoisted_81 = { class: "src-modal-search" }
const _hoisted_82 = { class: "src-modal-table-wrapper" }
const _hoisted_83 = { class: "src-data-table" }
const _hoisted_84 = { style: {"width":"40px","text-align":"center"} }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "渠道编码", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "渠道名称", -1))
const _hoisted_87 = { key: 0 }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "src-modal-empty"
}, "暂无数据", -1))
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = { style: {"text-align":"center"} }
const _hoisted_91 = ["value"]
const _hoisted_92 = { class: "src-modal-footer" }
const _hoisted_93 = {
  class: "src-modal",
  style: {"width":"860px"}
}
const _hoisted_94 = { class: "src-modal-header" }
const _hoisted_95 = { class: "src-modal-body" }
const _hoisted_96 = { class: "src-transfer-row" }
const _hoisted_97 = { class: "src-transfer-group" }
const _hoisted_98 = { class: "src-transfer-group-title" }
const _hoisted_99 = { class: "src-transfer" }
const _hoisted_100 = { class: "src-transfer-pane" }
const _hoisted_101 = { class: "src-transfer-pane-head" }
const _hoisted_102 = { class: "src-transfer-list" }
const _hoisted_103 = ["value"]
const _hoisted_104 = {
  key: 0,
  class: "src-transfer-empty"
}
const _hoisted_105 = { class: "src-transfer-ops" }
const _hoisted_106 = { class: "src-transfer-pane" }
const _hoisted_107 = { class: "src-transfer-pane-head" }
const _hoisted_108 = { class: "src-transfer-list" }
const _hoisted_109 = ["value"]
const _hoisted_110 = {
  key: 0,
  class: "src-transfer-empty"
}
const _hoisted_111 = { class: "src-transfer-group" }
const _hoisted_112 = { class: "src-transfer-group-title" }
const _hoisted_113 = { class: "src-transfer" }
const _hoisted_114 = { class: "src-transfer-pane" }
const _hoisted_115 = { class: "src-transfer-pane-head" }
const _hoisted_116 = { class: "src-transfer-list" }
const _hoisted_117 = ["value"]
const _hoisted_118 = {
  key: 0,
  class: "src-transfer-empty"
}
const _hoisted_119 = { class: "src-transfer-ops" }
const _hoisted_120 = { class: "src-transfer-pane" }
const _hoisted_121 = { class: "src-transfer-pane-head" }
const _hoisted_122 = { class: "src-transfer-list" }
const _hoisted_123 = ["value"]
const _hoisted_124 = {
  key: 0,
  class: "src-transfer-empty"
}
const _hoisted_125 = { class: "src-modal-footer" }
const _hoisted_126 = { class: "src-footer-hint" }
const _hoisted_127 = {
  class: "src-modal",
  style: {"width":"760px"}
}
const _hoisted_128 = { class: "src-modal-header" }
const _hoisted_129 = { class: "src-modal-body" }
const _hoisted_130 = { class: "src-cust-tags-bar" }
const _hoisted_131 = { class: "src-cust-tags-label" }
const _hoisted_132 = {
  key: 0,
  class: "src-placeholder"
}
const _hoisted_133 = ["onClick"]
const _hoisted_134 = { class: "src-cust-tabs" }
const _hoisted_135 = { class: "src-modal-search" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "全部省区", -1))
const _hoisted_137 = ["value"]
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "全部渠道", -1))
const _hoisted_139 = ["value"]
const _hoisted_140 = { class: "src-data-table" }
const _hoisted_141 = { style: {"width":"40px","text-align":"center"} }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "客户编码", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "客户名称", -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "渠道类型", -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "省区", -1))
const _hoisted_146 = { key: 0 }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "src-modal-empty"
}, "暂无匹配候选客户", -1))
const _hoisted_148 = [
  _hoisted_147
]
const _hoisted_149 = { style: {"text-align":"center"} }
const _hoisted_150 = ["value"]
const _hoisted_151 = { class: "src-province-name" }
const _hoisted_152 = { key: 1 }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "src-modal-empty"
}, "加载中…", -1))
const _hoisted_154 = [
  _hoisted_153
]
const _hoisted_155 = { key: 2 }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "src-modal-empty"
}, "没有更多了", -1))
const _hoisted_157 = [
  _hoisted_156
]
const _hoisted_158 = { class: "src-modal-footer" }
const _hoisted_159 = { class: "src-footer-hint" }
const _hoisted_160 = {
  class: "src-modal",
  style: {"width":"460px"}
}
const _hoisted_161 = { class: "src-modal-header" }
const _hoisted_162 = { class: "src-modal-body" }
const _hoisted_163 = { class: "src-batch-hint" }
const _hoisted_164 = { class: "src-batch-grid" }
const _hoisted_165 = { class: "src-filter-item" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "src-filter-label" }, "促销销售占比(%)", -1))
const _hoisted_167 = { class: "src-filter-item" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "src-filter-label" }, "让利占比-客户(%)", -1))
const _hoisted_169 = { class: "src-filter-item" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "src-filter-label" }, "让利占比-省区(%)", -1))
const _hoisted_171 = { class: "src-filter-item" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "src-filter-label" }, "老品让利幅度(%)", -1))
const _hoisted_173 = { class: "src-filter-item" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "src-filter-label" }, "新品让利幅度(%)", -1))
const _hoisted_175 = { class: "src-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("select", {
            class: "src-select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.level) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLevelChange && _ctx.handleLevelChange(...args))),
            disabled: _ctx.readonly
          }, _hoisted_13, 40, _hoisted_8), [
            [_vModelSelect, _ctx.level]
          ])
        ])
      ])
    ]),
    (_ctx.level)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.step2Title), 1),
          _createElementVNode("section", _hoisted_16, [
            (_ctx.level === 'customer' && !_ctx.readonly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "src-select",
                      placeholder: "请输入",
                      style: {"width":"200px"},
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rowSearchCode) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.rowSearchCode]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "src-select",
                      placeholder: "请输入",
                      style: {"width":"200px"},
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rowSearchName) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.rowSearchName]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.readonly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "src-btn src-btn-primary",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleAddRow && _ctx.handleAddRow(...args)))
                  }, "添加"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "src-btn src-btn-default src-btn-danger",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteSelectedRows && _ctx.deleteSelectedRows(...args)))
                  }, "删除"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "src-btn src-btn-default",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleImport && _ctx.handleImport(...args)))
                  }, "导入"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "src-btn src-btn-default",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.downloadTemplate && _ctx.downloadTemplate(...args)))
                  }, "下载模板"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "src-btn src-btn-fill",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openBatchFillModal && _ctx.openBatchFillModal(...args)))
                  }, "⚡ 批量填值")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("table", _hoisted_24, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (!_ctx.readonly)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_25, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectAll) = $event)),
                            onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.selectAll]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.level === 'channel')
                      ? (_openBlock(), _createElementBlock("th", _hoisted_26, "渠道类型"))
                      : (_ctx.level === 'shop')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _hoisted_27,
                            _hoisted_28,
                            _hoisted_29
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _hoisted_30,
                            _hoisted_31,
                            _hoisted_32,
                            _hoisted_33,
                            _hoisted_34
                          ], 64)),
                    _hoisted_35,
                    _hoisted_36,
                    _hoisted_37,
                    _hoisted_38,
                    _hoisted_39
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_ctx.visibleRows.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                        _createElementVNode("td", {
                          colspan: _ctx.emptyColspan,
                          class: "src-empty-cell"
                        }, _hoisted_43, 8, _hoisted_41)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleRows, (row, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row._key
                    }, [
                      (!_ctx.readonly)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((row.checked) = $event)
                            }, null, 8, _hoisted_45), [
                              [_vModelCheckbox, row.checked]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.level === 'channel')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_46, [
                            _createElementVNode("div", {
                              class: "src-multi-select",
                              onClick: _withModifiers(($event: any) => (_ctx.toggleRowMenu(row, 'ch')), ["stop"])
                            }, [
                              _createElementVNode("div", _hoisted_48, [
                                (row.channels.length === 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, "请选择渠道"))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.channels, (c) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: c.name,
                                    class: "src-tag"
                                  }, [
                                    _createTextVNode(_toDisplayString(c.name), 1),
                                    _createElementVNode("span", {
                                      class: "src-tag-close",
                                      onClick: _withModifiers(($event: any) => (_ctx.removeTag(row, 'channels', c)), ["stop"])
                                    }, "×", 8, _hoisted_50)
                                  ]))
                                }), 128))
                              ]),
                              _hoisted_51,
                              _withDirectives(_createElementVNode("div", {
                                class: "src-dropdown",
                                onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelOptions, (opt) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: opt.code,
                                    class: _normalizeClass(["src-dropdown-item", { selected: _ctx.isSelected(row.channels, opt.name) }]),
                                    onClick: ($event: any) => (_ctx.toggleTag(row, 'channels', { code: opt.code, name: opt.name }))
                                  }, _toDisplayString(opt.name), 11, _hoisted_52))
                                }), 128))
                              ], 512), [
                                [_vShow, row._chOpen]
                              ])
                            ], 8, _hoisted_47)
                          ]))
                        : (_ctx.level === 'shop')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("td", _hoisted_53, _toDisplayString(row.provinceName), 1),
                              _createElementVNode("td", _hoisted_54, [
                                _createElementVNode("div", {
                                  class: "src-multi-select",
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleRowMenu(row, 'ch')), ["stop"])
                                }, [
                                  _createElementVNode("div", _hoisted_56, [
                                    (row.channels.length === 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_57, "请选择渠道"))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.channels, (c) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: c.name,
                                        class: "src-tag"
                                      }, [
                                        _createTextVNode(_toDisplayString(c.name), 1),
                                        _createElementVNode("span", {
                                          class: "src-tag-close",
                                          onClick: _withModifiers(($event: any) => (_ctx.removeTag(row, 'channels', c)), ["stop"])
                                        }, "×", 8, _hoisted_58)
                                      ]))
                                    }), 128))
                                  ]),
                                  _hoisted_59,
                                  _withDirectives(_createElementVNode("div", {
                                    class: "src-dropdown",
                                    onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelOptions, (opt) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: opt.code,
                                        class: _normalizeClass(["src-dropdown-item", { selected: _ctx.isSelected(row.channels, opt.name) }]),
                                        onClick: ($event: any) => (_ctx.toggleTag(row, 'channels', { code: opt.code, name: opt.name }))
                                      }, _toDisplayString(opt.name), 11, _hoisted_60))
                                    }), 128))
                                  ], 512), [
                                    [_vShow, row._chOpen]
                                  ])
                                ], 8, _hoisted_55)
                              ]),
                              _createElementVNode("td", _hoisted_61, [
                                _createElementVNode("div", {
                                  class: "src-multi-select",
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleRowMenu(row, 'so')), ["stop"])
                                }, [
                                  _createElementVNode("div", _hoisted_63, [
                                    (row.salesOffices.length === 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_64, "请选择销售办"))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.salesOffices, (s) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: s.name,
                                        class: "src-tag"
                                      }, [
                                        _createTextVNode(_toDisplayString(s.name), 1),
                                        _createElementVNode("span", {
                                          class: "src-tag-close",
                                          onClick: _withModifiers(($event: any) => (_ctx.removeTag(row, 'salesOffices', s)), ["stop"])
                                        }, "×", 8, _hoisted_65)
                                      ]))
                                    }), 128))
                                  ]),
                                  _hoisted_66,
                                  _withDirectives(_createElementVNode("div", {
                                    class: "src-dropdown",
                                    onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["src-dropdown-item", { selected: _ctx.isSelected(row.salesOffices, '全部') }]),
                                      onClick: ($event: any) => (_ctx.toggleTag(row, 'salesOffices', { code: '', name: '全部' }))
                                    }, "全部", 10, _hoisted_67),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.soOptions, (so) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: so.code,
                                        class: _normalizeClass(["src-dropdown-item", { selected: _ctx.isSelected(row.salesOffices, so.name) }]),
                                        onClick: ($event: any) => (_ctx.toggleTag(row, 'salesOffices', { code: so.code, name: so.name }))
                                      }, _toDisplayString(so.name), 11, _hoisted_68))
                                    }), 128))
                                  ], 512), [
                                    [_vShow, row._soOpen]
                                  ])
                                ], 8, _hoisted_62)
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createElementVNode("td", null, _toDisplayString(row.erpCode), 1),
                              _createElementVNode("td", null, _toDisplayString(row.name), 1),
                              _createElementVNode("td", null, _toDisplayString(row.soStr), 1),
                              _createElementVNode("td", _hoisted_69, _toDisplayString(row.provinceName), 1),
                              _createElementVNode("td", null, _toDisplayString(row.channel), 1)
                            ], 64)),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "src-num-input",
                          placeholder: "0.0",
                          "onUpdate:modelValue": ($event: any) => ((row.promo) = $event),
                          readonly: _ctx.readonly
                        }, null, 8, _hoisted_70), [
                          [_vModelText, row.promo]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "src-num-input",
                          placeholder: "0.0",
                          "onUpdate:modelValue": ($event: any) => ((row.margin) = $event),
                          readonly: _ctx.readonly
                        }, null, 8, _hoisted_71), [
                          [_vModelText, row.margin]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "src-num-input",
                          placeholder: "0.0",
                          "onUpdate:modelValue": ($event: any) => ((row.provMargin) = $event),
                          readonly: _ctx.readonly
                        }, null, 8, _hoisted_72), [
                          [_vModelText, row.provMargin]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "src-num-input",
                          placeholder: "0.0",
                          "onUpdate:modelValue": ($event: any) => ((row.oldProd) = $event),
                          readonly: _ctx.readonly
                        }, null, 8, _hoisted_73), [
                          [_vModelText, row.oldProd]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "src-num-input",
                          placeholder: "0.0",
                          "onUpdate:modelValue": ($event: any) => ((row.newProd) = $event),
                          readonly: _ctx.readonly
                        }, null, 8, _hoisted_74), [
                          [_vModelText, row.newProd]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.visibleRows.length) + " 条", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
          _createElementVNode("button", {
            class: "src-btn src-btn-primary",
            disabled: _ctx.saving,
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.saveNewConfig && _ctx.saveNewConfig(...args)))
          }, "保存配置", 8, _hoisted_77)
        ]))
      : _createCommentVNode("", true),
    (_ctx.channelModalVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "src-modal-mask",
          onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.channelModalVisible = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createTextVNode("选择渠道"),
              _createElementVNode("span", {
                class: "src-modal-close",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.channelModalVisible = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "src-select",
                  placeholder: "搜索渠道编码/名称",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.channelModalKeyword) = $event)),
                  onInput: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.filterChannelModal && _ctx.filterChannelModal(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.channelModalKeyword]
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("table", _hoisted_83, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_84, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.channelModalSelectAll) = $event)),
                          onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.toggleChannelModalAll && _ctx.toggleChannelModalAll(...args)))
                        }, null, 544), [
                          [_vModelCheckbox, _ctx.channelModalSelectAll]
                        ])
                      ]),
                      _hoisted_85,
                      _hoisted_86
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.channelModalList.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_87, _hoisted_89))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelModalList, (ch) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: ch.code
                      }, [
                        _createElementVNode("td", _hoisted_90, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: ch.code,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.channelModalChecked) = $event))
                          }, null, 8, _hoisted_91), [
                            [_vModelCheckbox, _ctx.channelModalChecked]
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(ch.code), 1),
                        _createElementVNode("td", null, _toDisplayString(ch.name), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("button", {
                class: "src-btn src-btn-default",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.channelModalVisible = false))
              }, "取消"),
              _createElementVNode("button", {
                class: "src-btn src-btn-primary",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.confirmAddChannels && _ctx.confirmAddChannels(...args)))
              }, "确定")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.provinceModalVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "src-modal-mask",
          onClick: _cache[43] || (_cache[43] = _withModifiers(($event: any) => (_ctx.provinceModalVisible = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createTextVNode("选择省区与渠道"),
              _createElementVNode("span", {
                class: "src-modal-close",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.provinceModalVisible = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, "渠道类型（已选 " + _toDisplayString(_ctx.transferChSelected.length) + "）", 1),
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.toggleTrCandAll('ch', $event)))
                        }, null, 32),
                        _createTextVNode(" 待选 " + _toDisplayString(_ctx.chCandItems.length), 1)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "src-transfer-search",
                        placeholder: "搜索",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.trChCandSearch) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.trChCandSearch]
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chCandItems, (c) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: c.name,
                            class: "src-transfer-item"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: c.name,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.trChCandChecked) = $event))
                            }, null, 8, _hoisted_103), [
                              [_vModelCheckbox, _ctx.trChCandChecked]
                            ]),
                            _createElementVNode("span", null, _toDisplayString(c.name), 1)
                          ]))
                        }), 128)),
                        (_ctx.chCandItems.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_104, "无未选数据"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("button", {
                        class: "src-btn src-btn-default src-btn-sm",
                        onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.transferChRight && _ctx.transferChRight(...args)))
                      }, ">"),
                      _createElementVNode("button", {
                        class: "src-btn src-btn-default src-btn-sm",
                        onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.transferChLeft && _ctx.transferChLeft(...args)))
                      }, "<")
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.toggleTrSelAll('ch', $event)))
                        }, null, 32),
                        _createTextVNode(" 已选 " + _toDisplayString(_ctx.chSelItems.length), 1)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "src-transfer-search",
                        placeholder: "搜索",
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.trChSelSearch) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.trChSelSearch]
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chSelItems, (c) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: c.name,
                            class: "src-transfer-item"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: c.name,
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.trChSelChecked) = $event))
                            }, null, 8, _hoisted_109), [
                              [_vModelCheckbox, _ctx.trChSelChecked]
                            ]),
                            _createElementVNode("span", null, _toDisplayString(c.name), 1)
                          ]))
                        }), 128)),
                        (_ctx.chSelItems.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, "无已选数据"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", _hoisted_112, "省区（已选 " + _toDisplayString(_ctx.transferPrSelected.length) + "）", 1),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.toggleTrCandAll('pr', $event)))
                        }, null, 32),
                        _createTextVNode(" 待选 " + _toDisplayString(_ctx.prCandItems.length), 1)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "src-transfer-search",
                        placeholder: "搜索",
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.trPrCandSearch) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.trPrCandSearch]
                      ]),
                      _createElementVNode("div", _hoisted_116, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prCandItems, (p) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: p.code,
                            class: "src-transfer-item"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: p.code,
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.trPrCandChecked) = $event))
                            }, null, 8, _hoisted_117), [
                              [_vModelCheckbox, _ctx.trPrCandChecked]
                            ]),
                            _createElementVNode("span", null, _toDisplayString(p.name), 1)
                          ]))
                        }), 128)),
                        (_ctx.prCandItems.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_118, "无未选数据"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("button", {
                        class: "src-btn src-btn-default src-btn-sm",
                        onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.transferPrRight && _ctx.transferPrRight(...args)))
                      }, ">"),
                      _createElementVNode("button", {
                        class: "src-btn src-btn-default src-btn-sm",
                        onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.transferPrLeft && _ctx.transferPrLeft(...args)))
                      }, "<")
                    ]),
                    _createElementVNode("div", _hoisted_120, [
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.toggleTrSelAll('pr', $event)))
                        }, null, 32),
                        _createTextVNode(" 已选 " + _toDisplayString(_ctx.prSelItems.length), 1)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "src-transfer-search",
                        placeholder: "搜索",
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.trPrSelSearch) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.trPrSelSearch]
                      ]),
                      _createElementVNode("div", _hoisted_122, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prSelItems, (p) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: p.code,
                            class: "src-transfer-item"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: p.code,
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.trPrSelChecked) = $event))
                            }, null, 8, _hoisted_123), [
                              [_vModelCheckbox, _ctx.trPrSelChecked]
                            ]),
                            _createElementVNode("span", null, _toDisplayString(p.name), 1)
                          ]))
                        }), 128)),
                        (_ctx.prSelItems.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_124, "无已选数据"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("span", _hoisted_126, "已选 " + _toDisplayString(_ctx.transferChSelected.length) + " 个渠道 × " + _toDisplayString(_ctx.transferPrSelected.length) + " 个省区", 1),
              _createElementVNode("button", {
                class: "src-btn src-btn-default",
                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.provinceModalVisible = false))
              }, "取消"),
              _createElementVNode("button", {
                class: "src-btn src-btn-primary",
                onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.confirmAddProvinces && _ctx.confirmAddProvinces(...args)))
              }, "确定")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.customerModalVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "src-modal-mask",
          onClick: _cache[58] || (_cache[58] = _withModifiers(($event: any) => (_ctx.customerModalVisible = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_127, [
            _createElementVNode("div", _hoisted_128, [
              _createTextVNode("选择客户"),
              _createElementVNode("span", {
                class: "src-modal-close",
                onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.customerModalVisible = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_129, [
              _createElementVNode("div", _hoisted_130, [
                _createElementVNode("span", _hoisted_131, "已选 " + _toDisplayString(_ctx.modalSelectedCustCodes.length) + "：", 1),
                (_ctx.modalSelectedCustCodes.length === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_132, "暂未选择客户"))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalSelectedCustCodes, (key) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: key,
                    class: "src-cust-tag"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.custLabel(key)), 1),
                    _createElementVNode("span", {
                      class: "src-tag-close",
                      onClick: ($event: any) => (_ctx.removeCustCode(key))
                    }, "×", 8, _hoisted_133)
                  ]))
                }), 128)),
                (_ctx.modalSelectedCustCodes.length)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: "javascript:;",
                      class: "src-clear-all",
                      onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.modalSelectedCustCodes = []))
                    }, "清空"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_134, [
                _createElementVNode("span", {
                  class: _normalizeClass(["src-cust-tab", { active: _ctx.custModalTab === 'all' }]),
                  onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.switchCustTab('all')))
                }, "全部客户", 2),
                _createElementVNode("span", {
                  class: _normalizeClass(["src-cust-tab", { active: _ctx.custModalTab === 'selected' }]),
                  onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.switchCustTab('selected')))
                }, "已选客户", 2)
              ]),
              _createElementVNode("div", _hoisted_135, [
                _withDirectives(_createElementVNode("select", {
                  class: "src-select",
                  style: {"width":"160px"},
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.custFilterProvince) = $event)),
                  onChange: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.loadCustomers && _ctx.loadCustomers(...args)))
                }, [
                  _hoisted_136,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinceOptions, (p) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: p.code,
                      value: p.name
                    }, _toDisplayString(p.name), 9, _hoisted_137))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.custFilterProvince]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "src-select",
                  style: {"width":"160px","margin-left":"8px"},
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.custFilterChannel) = $event))
                }, [
                  _hoisted_138,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelOptions, (c) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: c.code,
                      value: c.name
                    }, _toDisplayString(c.name), 9, _hoisted_139))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.custFilterChannel]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "src-select",
                  style: {"width":"200px","margin-left":"8px"},
                  placeholder: "客户编码/名称",
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.custSearch) = $event)),
                  onInput: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.onCustSearchInput && _ctx.onCustSearchInput(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.custSearch]
                ])
              ]),
              _createElementVNode("div", {
                class: "src-modal-table-wrapper",
                onScroll: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.onCustScroll && _ctx.onCustScroll(...args)))
              }, [
                _createElementVNode("table", _hoisted_140, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_141, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          onChange: _cache[53] || (_cache[53] = ($event: any) => (_ctx.toggleCustModalAll($event)))
                        }, null, 32)
                      ]),
                      _hoisted_142,
                      _hoisted_143,
                      _hoisted_144,
                      _hoisted_145
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.custModalRows.length === 0 && !_ctx.custLoading)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_146, _hoisted_148))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.custModalRows, (c) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: c.rowKey
                      }, [
                        _createElementVNode("td", _hoisted_149, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: c.rowKey,
                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.modalSelectedCustCodes) = $event))
                          }, null, 8, _hoisted_150), [
                            [_vModelCheckbox, _ctx.modalSelectedCustCodes]
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(c.code), 1),
                        _createElementVNode("td", null, _toDisplayString(c.name), 1),
                        _createElementVNode("td", null, _toDisplayString((c.channelTypes && c.channelTypes[0] && c.channelTypes[0].name) || '-'), 1),
                        _createElementVNode("td", _hoisted_151, _toDisplayString(c.provinceName || '通用省区'), 1)
                      ]))
                    }), 128)),
                    (_ctx.custLoading)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_152, _hoisted_154))
                      : (_ctx.custModalTab === 'all' && !_ctx.custHasMore && _ctx.custModalRows.length > 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_155, _hoisted_157))
                        : _createCommentVNode("", true)
                  ])
                ])
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("span", _hoisted_159, "已选 " + _toDisplayString(_ctx.modalSelectedCustCodes.length) + " 个客户", 1),
              _createElementVNode("button", {
                class: "src-btn src-btn-default",
                onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.customerModalVisible = false))
              }, "取消"),
              _createElementVNode("button", {
                class: "src-btn src-btn-primary",
                onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.confirmAddCustomers && _ctx.confirmAddCustomers(...args)))
              }, "确定")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.batchFillVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "src-modal-mask",
          onClick: _cache[67] || (_cache[67] = _withModifiers(($event: any) => (_ctx.batchFillVisible = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_160, [
            _createElementVNode("div", _hoisted_161, [
              _createTextVNode("批量填值"),
              _createElementVNode("span", {
                class: "src-modal-close",
                onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.batchFillVisible = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("div", _hoisted_163, [
                _createTextVNode("当前已勾选 "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.checkedRowCount), 1),
                _createTextVNode(" 行，输入需要应用的比例值，留空的项将保持原数值不变。")
              ]),
              _createElementVNode("div", _hoisted_164, [
                _createElementVNode("div", _hoisted_165, [
                  _hoisted_166,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "src-select",
                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.batchVals.promo) = $event)),
                    placeholder: "0.0"
                  }, null, 512), [
                    [_vModelText, _ctx.batchVals.promo]
                  ])
                ]),
                _createElementVNode("div", _hoisted_167, [
                  _hoisted_168,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "src-select",
                    "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.batchVals.margin) = $event)),
                    placeholder: "0.0"
                  }, null, 512), [
                    [_vModelText, _ctx.batchVals.margin]
                  ])
                ]),
                _createElementVNode("div", _hoisted_169, [
                  _hoisted_170,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "src-select",
                    "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.batchVals.provMargin) = $event)),
                    placeholder: "0.0"
                  }, null, 512), [
                    [_vModelText, _ctx.batchVals.provMargin]
                  ])
                ]),
                _createElementVNode("div", _hoisted_171, [
                  _hoisted_172,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "src-select",
                    "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.batchVals.oldProd) = $event)),
                    placeholder: "0.0"
                  }, null, 512), [
                    [_vModelText, _ctx.batchVals.oldProd]
                  ])
                ]),
                _createElementVNode("div", _hoisted_173, [
                  _hoisted_174,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "src-select",
                    "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.batchVals.newProd) = $event)),
                    placeholder: "0.0"
                  }, null, 512), [
                    [_vModelText, _ctx.batchVals.newProd]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_175, [
              _createElementVNode("button", {
                class: "src-btn src-btn-default",
                onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.batchFillVisible = false))
              }, "取消"),
              _createElementVNode("button", {
                class: "src-btn src-btn-primary",
                onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.confirmBatchFill && _ctx.confirmBatchFill(...args)))
              }, "确定应用")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}